import React, { useRef, useEffect, useState } from 'react';
import { Row, Select, Card, Divider, Col, Progress, Button, Carousel, FloatButton, Skeleton, Typography, Form, Modal, Spin, Radio, Input, Space, message, Layout, Avatar } from 'antd';
import { StarOutlined, InfoCircleOutlined, RightCircleFilled, LeftCircleFilled, BarChartOutlined, AudioOutlined, ReadOutlined, SolutionOutlined, UserOutlined, PlayCircleOutlined, FileImageOutlined, FileTextOutlined } from '@ant-design/icons';
import { fetchApi } from '../../../services/api';
import { Chart } from "react-google-charts";
import { useNavigate } from 'react-router-dom';
import constants from '../../../constants/constants';
import { COOKIE, createCookie, deleteCookie, getCookie } from '../../../services/cookie';
import axios from "axios";
import { success } from '../../../functions/functions';
import PhoneInput from "react-phone-input-2";
import { handleKeyboardAction, getParentDomain } from '../../../globalFunctions/GlobalFunctions';
import { useContext } from "react";
import { Context } from "../../../Context";
const { TextArea } = Input;
const { Content } = Layout;

const Dashboard = () => {
	const [form] = Form.useForm();
	const [messageApi, contextHolder] = message.useMessage();
	const carouselRef = useRef();
	const { setUser, setChapterList } = useContext(Context);
	const navigate = useNavigate();
	const handleNext = () => carouselRef.current.next();
	const handlePrev = () => carouselRef.current.prev();
	const [dashboardData, setDashboardData] = useState({});
	const colorCode = constants.ColorCode;
	const [testPerCard, setTestPerCard] = useState({})
	const [graphData, setGraphData] = useState([]);
	const [showCarouselbutton, setShowCarouselbutton] = useState(false);
	const [isFeedbackModalVisible, setIsFeedbackModalVisible] = useState(false);
	const [otherMessage, setOtherMessage] = useState(false);
	const [firstSubmit, setFirstSubmit] = useState(false);
	const [testPausedCount, setTestPausedCount] = useState(0);
	const [updateprofileModalVisible, setUpdateProfileModalVisible] = useState(false);

	//UpdateProfile states
	const [otheruniversity, setOtherUniversity] = useState(false);
	const [universityop, setUniversityop] = useState(false);
	const [stateop, setStateop] = useState(true);
	const [otherrole, setOtherRole] = useState(false);
	const [firstname, setFirstName] = useState('');
	const [lastname, setLastName] = useState('');
	const [emailid, setEmailId] = useState('');
	const [roleoption, setRoleOption] = useState();
	const [universityoption, setUniversityOption] = useState('');
	const [statevalue, setStateValue] = useState('');
	const [countryvalue, setCountryValue] = useState('238');
	const [states, setStates] = useState([]);
	const [universities, setUniversities] = useState([]);
	const [countrycode, setCountrycode] = useState('US');
	const [countryObject, setCountryObject] = useState([]);
	const keyboardFocusableClass = constants.KeyboardFocusableClass;
	const [isAutoPlay, setIsAutoPlay] = useState(true);

	const userId = "16";

	var chartOptions = {
		chartArea: { width: '100%' },
		legend: { position: 'none' },
		vAxes: [
			{
				minValue: 0,
				ticks: [0, 20, 40, 60, 80, 100],
			},
		],
	}
	useEffect(() => {
		if (process.env.REACT_APP_ENV === "qa" || process.env.REACT_APP_ENV === "dev") {
			createCookie(COOKIE.UserId, userId, null, "/");
			getDashboardData();
		} else {
			let userId = getCookie(COOKIE.UserId);
			if (userId) {
				getDashboardData();
				getStudentDetails();
			} else {
				fetchUrlParameters();
			}
		}
		getCountries();
	}, []);
	useEffect(() => {
		const updateTabIndex = () => {
			const slides = document.querySelectorAll(".ant-carousel .slick-slide");
			slides.forEach((slide) => {
				const isActive = slide.classList.contains("slick-active");
				// Make slide itself not focusable
				slide.setAttribute("tabindex", "-1");
				const focusable = slide.querySelectorAll("a, button");
				focusable.forEach((el) => {
					el.setAttribute("tabindex", isActive ? "0" : "-1");
				});
			});
		};
		updateTabIndex();

		const observer = new MutationObserver(updateTabIndex);
		const track = document.querySelector(".ant-carousel .slick-track");
		if (track) {
			observer.observe(track, {
				attributes: true,
				subtree: true,
				attributeFilter: ["class"]
			});
		}
		return () => observer.disconnect();
	}, []);
	const getCountries = () => {
		fetchApi(`/countries`, 'get').then((res) => {
			if (res?.data) {
				setCountryObject(res?.data);
			}
		})
	}

	const getStudentDetails = () => {
		let userId = getCookie(COOKIE.UserId);
		fetchApi(`/get-student-data/${userId}`, 'get').then((res) => {
			if (res?.data) {
				setFirstName(res?.data[0]?.stud_firstname);
				setLastName(res?.data[0]?.stud_lastname);
				setEmailId(res?.data[0]?.stud_email);
			}
		})
	}

	const fetchUrlParameters = () => {
		let queryString = window.location.href;
		var tokenId = queryString.substring(queryString.lastIndexOf('?') + 1);
		var tempValueHref = queryString.substring(queryString.lastIndexOf('/') + 1);
		getToken(tokenId);
	};
	const getToken = (tokenId) => {
		axios({
			method: "GET",
			url: `${constants.ApiUrl}` + `/get-token/` + `${tokenId}`,
		})
			.then((res) => {
				if (res?.data?.code !== 400) {
					setUser({
						firstName: res?.data?.data?.stud_firstname,
						lastName: res?.data?.data?.stud_lastname,
					});
					createCookie(COOKIE.UserId, res?.data?.data?.stud_id, null, "/");
					createCookie(COOKIE.Token, res?.data?.data?.token, null, "/", getParentDomain());
					createCookie(COOKIE.FirstName, res?.data?.data?.stud_firstname, null, "/");
					createCookie(COOKIE.LastName, res?.data?.data?.stud_lastname, null, "/");
					sessionStorage.setItem("UserIdSession", res?.data?.data?.stud_id);
					getStudentDetails();
					getDashboardData();
				} else {
					message.error("Invalid token");
					deleteCookie(COOKIE.UserId, "/");
					deleteCookie(COOKIE.Token, "/", getParentDomain());
					deleteCookie(COOKIE.FirstName, "/");
					deleteCookie(COOKIE.LastName, "/");
					if (process.env.REACT_APP_ENV === "staging") {
						window.location.href = constants.StagingWebsiteURL;
					} else {
						window.location.href = constants.LiveWebsiteURL;
					}
				}
			})
			.catch((err) => {
				deleteCookie(COOKIE.UserId, "/");
				deleteCookie(COOKIE.Token, "/", getParentDomain());
				deleteCookie(COOKIE.FirstName, "/");
				deleteCookie(COOKIE.LastName, "/");
				if (process.env.REACT_APP_ENV === "staging") {
					window.location.href = constants.StagingWebsiteURL;
				} else {
					window.location.href = constants.LiveWebsiteURL;
				}
			});
	}
	const getChapterListApi = () => {
		let chapterList = localStorage.getItem("chapter-list");
		if (chapterList === null) {
			fetchApi(`/list-chapters`, "get").then((res) => {
				if (res && res.data && res.data !== null && res.data !== undefined) {
					localStorage.setItem("chapter-list", JSON.stringify(res.data));
					setChapterList(res.data);
				} else {
					setChapterList([]);
				}
			});
		}
	};
	const getDashboardData = () => {
		let userIdCookieValue = getCookie(COOKIE.UserId);
		if (process.env.REACT_APP_ENV === "qa" || process.env.REACT_APP_ENV === "dev") {
			userIdCookieValue = userId;
		} else {
			userIdCookieValue = getCookie(COOKIE.UserId);
		}
		fetchApi(`/dashboard/${userIdCookieValue}`, "get").then((res) => {
			if (res?.code === 200) {
				// localStorage.setItem('userType',"1");
				if (res?.data?.latest_3_scores_sr?.length > 0) {
					const gdata = res?.data?.latest_3_scores_sr;
					const formatedGfdata = [
						["Chapters", "Score", "Style"],
						...gdata.map(item => [
							`${item?.label?.replace("Chapter", "Ch.")} (#${item?.attempt})`,
							item?.score,
							item?.style
						])
					];
					formatedGfdata[0][formatedGfdata[0].length - 1] = { role: "style" };
					setGraphData(formatedGfdata);
				}
				setUser({
					firstName: res?.data?.first_name,
					lastName: res?.data?.last_name,
				});
				getChapterListApi();
				setTestPausedCount(Number(res?.data?.test_paused_count));
				let testpercard = calculatePercent(res?.data?.tests?.total, res?.data?.tests?.completed);
				if (Number(res?.data?.tests?.completed) === testpercard?.fifty || Number(res?.data?.tests?.completed) === testpercard.twentyfive || Number(res?.data?.tests?.completed) === testpercard.seventyfive || Number(res?.data?.tests?.completed) === res?.data?.tests?.total) {
					setShowCarouselbutton(true);
				}
				if ((Number(res?.data?.test_paused_count) > 0)) {
					setShowCarouselbutton(true);
				}
				setTestPerCard(testpercard);
				setDashboardData(res.data);
				if (res?.data?.is_present === false) {
					setUpdateProfileModalVisible(true);
					//navigate('/update-profile')
				} else {
					setUpdateProfileModalVisible(false);
					// navigate('/dashboard',{ replace: true })
				}
				if (res?.data?.is_overall_submitted == true) {
					setFirstSubmit(true);
				} else {
					setFirstSubmit(false);
				}
			} else {
				setDashboardData({});
			}
		})
	};
	const testScore = () => {
		navigate('/compare-score');
	};
	const feedback = () => {
		setIsFeedbackModalVisible(true);
		setOtherMessage(false);
	};
	const myNotes = () => {
		navigate('/notes')
	};

	const routeToChapter = (chapter_id) => {
		const state = {
			chapter_id: chapter_id
		};
		navigate('/chapter-resources', { state });
	};
	const calculatePercent = (typetotal, completed) => {
		return {
			twentyfive: completed == Math.ceil(0.25 * typetotal) ? Math.ceil(0.25 * typetotal) : Math.floor(0.25 * typetotal),
			fifty: completed == Math.ceil(0.50 * typetotal) ? Math.ceil(0.50 * typetotal) : Math.floor(0.50 * typetotal),
			seventyfive: completed == Math.ceil(0.75 * typetotal) ? Math.ceil(0.75 * typetotal) : Math.floor(0.75 * typetotal),
		};
	}
	const handleFeedbackCancel = () => {
		form.resetFields();
		setIsFeedbackModalVisible(false);
	};
	const onChangeFeedbackQ2 = e => {
		if (e.target.value === 7) {
			setOtherMessage(true);
		}
		else {
			setOtherMessage(false);
		}
	};
	const handleOtherFeedBackValidation = (rule, value, callback) => {
		try {
			if (value) {
				if (value.trim() === "") {
					throw new Error(constants.FeedbackMessageError);
				}
			} else {
				throw new Error(constants.FeedbackMessageError);
			}
			callback(); // < -- this
		} catch (err) {
			callback(err);
		}
	};
	const submitFeedbackform = (values) => {
		let user = getCookie(COOKIE.UserId);
		let feedbackformPayload = null;
		let commentFeedbackFormPayload = null;

		otherMessage ?
			feedbackformPayload = {
				stud_id: user,
				is_book: values.bookreq,
				product_source: values.hearabtbook,
				other_source: 'Other',
				product_rating: values.prodrat,
				test_rating: values.chaltest,
				overall_comments: values.feedbackcomment !== '' ? values.feedbackcomment : '',
				first_submit: true,
				other_feedback: values.otherFeedback,
			}
			:
			feedbackformPayload = {
				stud_id: user,
				is_book: values.bookreq,
				product_source: values.hearabtbook,
				// other_source: values.otherFeedback,
				product_rating: values.prodrat,
				test_rating: values.chaltest,
				overall_comments: values.feedbackcomment !== '' ? values.feedbackcomment : '',
				first_submit: true,
			}

		commentFeedbackFormPayload = {
			stud_id: user,
			overall_comments: values.commentInfo,
			first_submit: false,
		}

		const feedbackFormPayload = firstSubmit ? commentFeedbackFormPayload : feedbackformPayload;
		fetchApi(`/feedback`, 'post', feedbackFormPayload).then((res) => {
			if (res.code === 200) {
				handleFeedbackCancel();
				form.resetFields();
				success('success', constants.feedbackSentSuccess, 'afterQaddsuccess', messageApi);
			} else {
				form.resetFields();
			}

			if (res.is_overall_submitted == true) {
				setFirstSubmit(true);
			}
		})
	}
	const feedbackModal = () => {
		return <Modal footer={false} title={<span>{constants.FeedbackHeader}</span>} centered open={isFeedbackModalVisible} onCancel={handleFeedbackCancel}
		>
			{/* <Spin size="large"> */}
			{!firstSubmit
				?
				<Form name="feedback_form" form={form} autoComplete="off" layout="vertical" onFinish={submitFeedbackform}>
					<>
						<Form.Item
							label={constants.FeedbackQ1}
							name="bookreq"
							rules={[
								{
									required: true,
									message: constants.FeedbackOptionError,
								},
							]}
						>
								<Radio.Group
								>
									<Radio value={0}>{constants.BookReq1}</Radio>
									<Radio value={1}>{constants.BookReq2}</Radio>
								</Radio.Group>
						</Form.Item>
						<Form.Item
							label={constants.FeedbackQ2}
							name="hearabtbook"
							rules={[
								{
									required: true,
									message: constants.FeedbackOptionError,
								},
							]}
						>
								<Radio.Group onChange={onChangeFeedbackQ2}>
									<Row gutter={[8, 8]}>
										<Col xs={24} lg={12} className="pl-0"><Radio value={0}>{constants.HearAbtBookOption8}</Radio></Col>
										<Col xs={24} lg={12} className="pl-0"><Radio value={1}>{constants.HearAbtBookOption1}</Radio></Col>
										<Col xs={24} lg={12} className="pl-0"><Radio value={2}>{constants.HearAbtBookOption2}</Radio></Col>
										<Col xs={24} lg={12} className="pl-0"><Radio value={3}>{constants.HearAbtBookOption3}</Radio></Col>
										<Col xs={24} lg={12} className="pl-0"><Radio value={4}>{constants.HearAbtBookOption4}</Radio></Col>
										<Col xs={24} lg={12} className="pl-0"><Radio value={5}>{constants.HearAbtBookOption5}</Radio></Col>
										<Col xs={24} lg={12} className="pl-0"><Radio value={6}>{constants.HearAbtBookOption6}</Radio></Col>
										<Col xs={24} lg={12} className="pl-0"><Radio value={7}>{constants.HearAbtBookOption7}</Radio></Col>
									</Row>
								</Radio.Group>
						</Form.Item>
						{otherMessage ?
							<Form.Item
								name="otherFeedback"
								rules={[
									{
										required: true,
										message: "",
									},
									{ validator: handleOtherFeedBackValidation },
								]}>
								<Input className="w-100" aria-label="Other feedback source" />
							</Form.Item>
							: null
						}
						<Form.Item
							label={<span>{constants.FeedbackQ3}</span>}
							name="chaltest"
							rules={[
								{
									required: true,
									message: constants.FeedbackOptionError,
								},
							]}
						>
								<Radio.Group
								>
									<Radio value={0}>{constants.ChalTestOpt1}</Radio>
									<Radio value={1}>{constants.ChalTestOpt2}</Radio>
									<Radio value={2}>{constants.ChalTestOpt3}</Radio>
								</Radio.Group>
						</Form.Item>
						<Form.Item
							label={<span className="pl-3">{constants.FeedbackQ4}</span>}
							name="prodrat"
						>
								<Radio.Group
								>
									<Radio value={0}>{constants.RatingOpt1}</Radio>
									<Radio value={1}>{constants.RatingOpt2}</Radio>
									<Radio value={2}>{constants.RatingOpt3}</Radio>
									<Radio value={3}>{constants.RatingOpt4}</Radio>
								</Radio.Group>
						</Form.Item>
					</>
					<Form.Item name="feedbackcomment"
						className=""
					>
						<TextArea placeholder="Comments..." allowClear aria-label="Comments"
						/>
					</Form.Item>
					<div className='text-right'>
						<Space>
							<Button
								key="submit"
								type="primary"
								className="bg-green-800"
								htmlType="submit"
							>
								Submit
							</Button>
							<Button onClick={handleFeedbackCancel} className="text-white border border-blue-600 bg-blue-600" >
								Cancel
							</Button>
						</Space>
					</div>
				</Form>
				:
				<Form form={form} onFinish={submitFeedbackform}>
					<Form.Item name="commentInfo"
						rules={
							[{
								required: true,
								message: constants.EmptyCommentError
							},
							{
								validator: (_, value) =>
									value != '' ? Promise.resolve() : Promise.reject(new Error(constants.mandatoryField)),
							},
							]
						}
					>
						<TextArea placeholder="Comments..." allowClear aria-label="Comments" />
					</Form.Item>
					<Form.Item className="relative">
						<div className="absolute right-0">
							<Button
								type="primary"
								htmlType="submit"
								className='font-semibold'
							// disabled={formError}
							>Submit</Button>
							<Button className='ml-2 font-semibold bg-blue-600 text-white' onClick={handleFeedbackCancel}>Cancel</Button>
						</div>
					</Form.Item>
				</Form>
			}
			{/* </Spin> */}
		</Modal>
	};
	const getTestPerCard = () => {
		if (Number(dashboardData?.tests?.completed) === testPerCard.twentyfive) {
			return <Row>
				<Col xs={12} sm={10} md={5} lg={10} xl={5}>
					<StarOutlined className='text-yellow-400 text-7xl' aria-hidden="true" />
				</Col>
				<Col xs={12} sm={14} md={19} lg={14} xl={19}>
					<div>
						<h2 className='text-base'><strong>{constants.CardTitle[25]}</strong></h2>
						<h3 className='mt-3'><strong>{constants.OptionPercentChapterTest[25]}</strong></h3>
					</div>
				</Col>
			</Row>
		} else if (Number(dashboardData?.tests?.completed) === testPerCard.fifty) {
			return <Row>
				<Col xs={12} sm={10} md={5} lg={10} xl={5}>
					<StarOutlined className='text-yellow-400 text-7xl' aria-hidden="true" />
				</Col>
				<Col xs={12} sm={14} md={19} lg={14} xl={19}>
					<div>
						<h2 className='text-base'><strong>{constants.CardTitle[50]}</strong></h2>
						<h3 className='mt-3'><strong>{constants.OptionPercentChapterTest[50]}</strong></h3>
					</div>
				</Col>
			</Row>
		} else if (Number(dashboardData?.tests?.completed) === testPerCard.seventyfive) {
			return <Row>
				<Col xs={12} sm={10} md={5} lg={10} xl={5}>
					<StarOutlined className='text-yellow-400 text-7xl' aria-hidden="true" />
				</Col>
				<Col xs={12} sm={14} md={19} lg={14} xl={19}>
					<div>
						<h2 className='text-base'><strong>{constants.CardTitle[75]}</strong></h2>
						<h3 className='mt-3'><strong>{constants.OptionPercentChapterTest[75]}</strong></h3>
					</div>
				</Col>
			</Row>
		} else if (Number(dashboardData?.tests?.completed) === Number(dashboardData?.tests?.total)) {
			return <Row>
				<Col xs={12} sm={10} md={5} lg={10} xl={5}>
					<StarOutlined className='text-yellow-400 text-7xl' aria-hidden="true" />
				</Col>
				<Col xs={12} sm={14} md={19} lg={14} xl={19}>
					<div>
						<h2 className='text-base'><strong>{constants.CardTitle[100]}</strong></h2>
						<h3 className='mt-3'><strong>{constants.OptionPercentChapterTest[100]}</strong></h3>
					</div>
				</Col>
			</Row>
		}
	};

	useEffect(() => {
		roleoption && roleoption == '3' ? setOtherRole(true) : setOtherRole(false);
		if (countrycode) {
			getStates();
			getUniversities();
		}
	}, [roleoption, countrycode])

	const getStates = () => {
		fetchApi(`/states?country_code=${countrycode}`, 'get').then((res) => {
			if (res?.data) {
				setStates(res?.data);
			}
		})
	}

	const getRolevalue = (value) => {
		setRoleOption(value);
	}
	const getStateValue = (value) => {
		setStateValue(value);
	}
	const getUniversities = () => {
		fetchApi(`/universities?country_code=${countrycode}`, 'get').then((res) => {
			if (res?.data) {
				setUniversities(res?.data);
				Object.entries(res.data).forEach(([key, value]) => {
					if (key == "Alaska") {
						for (let i = 0; i < value?.universities.length; i++) {
							if (value?.universities?.region_code === undefined) {
								value?.universities?.splice(i, 1);
							}
						}
					}
				});
			} else {
				setUniversities([]);
			}
		})
	}
	const getCountryValue = (value, option) => {
		setCountryValue(value);
		const countryCode = countryObject.filter((eachCountry, index) => (eachCountry.country_id == value));
		setCountrycode(countryCode[0].country_code)
		if (option.children !== 'United States') {
			setUniversityop(true);
			setStateop(true);
		} else {
			setUniversityop(false);
			setStateop(true);
		}
	}
	const getUniversityvalue = (value, option) => {
		setStateValue(option.props.region);
		setUniversityOption(value);
		if (option.children === 'Other') {
			setUniversityOption(null);
			setOtherUniversity(true);
		} else {
			setOtherUniversity(false);
		}
	}
	//UpdateProfile form validations
	const validateEmail = (_rule, value, callback) => {
		try {
			if (value) {
				const emailReg = /^([a-zA-Z0-9_])+([^#<>(){}|![\]\\,;:\s@"-])*@([a-zA-Z]+\.[a-zA-Z]{2,3})$/;
				if (emailReg.test(value) === false) {
					throw new Error(`${value} is not valid!`);
				}
				if (value === emailid) {
					throw new Error(constants.duplicateIdError);
				}
			}
			callback();
		} catch (err) {
			callback(err);
		}
	};
	const validatePhone = (_rule, value, callback) => {
		try {
			if (value != '') {
				let numberValue = /^[0-9]+$/;
				if (numberValue.test(value) === false) {
					throw new Error('');
				}
			}
			callback();
		} catch (err) {
			callback(err);
		}
	};

	//Submit UpdateProfile form info
	const updateStudentProfileData = (values) => {
		let user = getCookie(COOKIE.UserId);
		let withoutUniversityPayload = null;
		let withUniversityPayload = null;
		withUniversityPayload = {
			stud_id: user,
			alternate_email: values.alternatemail,
			contact_no: values.contactnumber,
			country_id: values.country,
			state_id: statevalue === '-' ? null : statevalue,
			university_id: universityoption === 'NA' ? null : universityoption,
			//university_id: universityoption === 'NA' ? 0 : universityoption === 0 ? null : universityoption,
			other_university: universityoption === 'NA' ? 'NA' : values.otherUniversity,
			role: values.role,
			occupation: values.otherRole,
		}
		withoutUniversityPayload = {
			stud_id: user,
			alternate_email: values.alternatemail,
			contact_no: values.contactnumber,
			country_id: values.country,
			role: values.role,
			occupation: values.otherRole
		}
		const newPayload = !universityop ? withUniversityPayload : withoutUniversityPayload;
		fetchApi(`/update-student-profile`, 'put', newPayload).then((res) => {
			if (res?.code == 200) {
				success('success', constants.sucessfulProfileupdation, 'afterQaddsuccess', messageApi);
				setUpdateProfileModalVisible(false);
				navigate('/dashboard');
			} else {
				success('error', constants.profileUpdationError, 'afterQaddsuccess', messageApi);
				setUpdateProfileModalVisible(true);
			}
		})
	}

	const handleUpdateProfileCancel = () => {
		form.resetFields();
	};

	const filterOption = (input, option) =>
		(option?.children.toLowerCase().includes(input.toLowerCase()));

	//Display updateProfile form inside Modal
	const displayUpdateProfileForm = () => {
		return (
			<Modal open={updateprofileModalVisible} footer={null} className='updateProfileformModal'  title={<span className="sr-only">Update your profile</span>}>
				<div className="flex justify-center mt-5">
					<Row>
						<Col style={{ width: '520px' }}>
							<Card className='relative bg-sky-100 border-slate-300 border-2 w-full'
								hoverable>
								<div className="flex flex-col justify-center items-center relative top_position"><div className=""><UserOutlined className="relative student_user bg-slate-300 width-70 text-5xl rounded-full text-white !inline-block" aria-hidden="true" /></div><div className="text-base"><strong>{`${firstname}  ${lastname}`.toUpperCase()}</strong></div><div className="font-semibold text-sm">{emailid}</div></div>
								<Divider className='-mt-12' />
								<h2 className="text-center text-base font-semibold relative -top-3">Update your profile</h2>

								<Form form={form} layout="vertical" className='updateProfileForm' onFinish={updateStudentProfileData} initialValues={
									{
										country: countryvalue,
									}
								} autoComplete="on">
									<Form.Item label="Alternate Email"
										name="alternatemail"
										rules={[
											{
												type: 'email',
												message: '',
											},
											{
												required: true,
												message: 'Please input your E-mail!',
											},
											{ validator: validateEmail },
										]}
										tooltip={{
											title: constants.alternateEmailText,
											icon: <InfoCircleOutlined aria-hidden="true" />,
										}}
									>
										<Input autoComplete="email"></Input>
									</Form.Item>
									<Form.Item label="Contact Number"
										name="contactnumber"
										rules={[
											{
												required: true,
												message: constants.requiredContactNumber,
											},
											{ validator: validatePhone },
										]}
									>
										<PhoneInput country={'us'} placeholder="1(999)123-4567" className="contactInput" inputProps={{ 'aria-label': 'Contact Number', autoComplete: 'tel' }} />
									</Form.Item>
									<Form.Item label="Role"
										name="role"
										rules={[
											{
												required: true,
												message: constants.requiredRole,
											},
										]}
									>
										<Select onChange={getRolevalue} virtual={false}>
											{constants.roleOptions.map((role, index) => (
												<Select.Option key={role} value={index}>
													{role}
												</Select.Option>
											))}
										</Select>
									</Form.Item>
									{otherrole ?
										<Form.Item label="Occupation"
											name="otherRole"
											rules={[
												{
													required: true,
													message: constants.requiredOccupation,
												},
											]}
										>
											<Input autoComplete="organization-title"></Input>
										</Form.Item>
										:
										<div></div>
									}
									<Form.Item label="Country"
										name="country"
										rules={[
											{
												required: true,
												message: constants.requiredCountry,
											},
										]}
									>
										<Select onChange={getCountryValue} showSearch filterOption={filterOption} virtual={false}>
											{countryObject.map((country) => (
												<Select.Option key={country?.country_id} value={country?.country_id}>
													{country?.country_name}
												</Select.Option>
											))}
										</Select>
									</Form.Item>

									{!stateop
										?
										<Form.Item label="State"
											name="state"
											rules={[
												{
													required: !stateop ? true : false,
													message: constants.requiredState,
												},
											]}
										>
											<Select onChange={getStateValue} showSearch filterOption={filterOption} virtual={false}>
												{states.map((state, index) => (
													<Select.Option key={index} value={state?.region_id}>
														{state?.region_name}
													</Select.Option>
												))}
											</Select>
										</Form.Item>
										:
										<div></div>
									}
									{!universityop
										?
										<Form.Item label="University"
											name="university"
											rules={[
												{
													required: true,
													message: constants.requiredUniversity,
												},
											]}
										>
											<Select
												virtual={false}
												onChange={getUniversityvalue}
												showSearch
												filterOption={(input, option) => {
													if (option.children) {
														return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ? true : false;
													} else if (option.label) {
														return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 ? true : false;
													}
												}}
											>
												{universities &&
													Object.entries(universities).map(([key, value]) => (
														<Select.OptGroup label={key} key={key}>
															{value && value.universities && value.universities.length > 0 &&
																value.universities.map((uni) => (
																	<Select.Option region={uni.region_id} value={uni.university_id} key={uni.university_id}>{uni.university_name + (uni.city ? "," + uni.city : "")}</Select.Option>
																))}
														</Select.OptGroup>
													))}
											</Select>
										</Form.Item>
										:
										<div></div>
									}

									{otheruniversity ?
										<Form.Item label="University Name"
											name="otherUniversity"
											rules={[
												{
													required: true,
													message: constants.requiredUniversity,
												},
											]}
										>
											<Input autoComplete="organization"></Input>
										</Form.Item>
										:
										<div></div>
									}
									<Form.Item className="relative"
									>
										<div className="absolute right-0">
											<Button
												type="primary"
												htmlType="submit"
												className='font-semibold'>Update</Button>
											<Button className='ml-2 font-semibold bg-blue-600 text-white' onClick={handleUpdateProfileCancel}>Reset</Button>
										</div>
									</Form.Item>
								</Form>

							</Card>
							{contextHolder}
						</Col>
					</Row>

				</div>
			</Modal>
		)
	};
	const getGraphDataDescription = () => {
		if (dashboardData?.latest_3_scores_sr) {
			// return `Bar chart shows the latest ${dashboardData?.latest_3_scores_sr?.length} test scores. ` +
			// 	dashboardData?.latest_3_scores_sr
			// 		.map(
			// 			item =>
			// 				`${item.label}, attempt ${item.attempt}, score ${item.score} out of ${item.total}.`
			// 		)
			// 		.join(" ");
			return constants.LastThreeTestScoreSR
		} else {
			return "No test scores available to display in the bar chart.";
		}
	};
	return (
		<>
			<div className='container mx-auto'>
				<h1 className='sr-only'>Dashboard</h1>
				<Row gutter={[{
					xs: 0,
					sm: 0,
					md: 24,
					lg: 24,
					xl: 12
				}, {
					xs: 24,
					sm: 24,
					md: 24,
					lg: 16,
					xl: 24
				}]}>
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<div className='rounded-lg border border-red-900 bg-pink-100 p-3 h-full'>
							<h2 className='pb-3 font-semibold'>My Progress</h2>
							{parseInt(dashboardData?.flashcards?.completed) > 0
								|| parseInt(dashboardData?.tests?.completed) > 0
								|| parseInt(dashboardData?.tutorials?.completed) > 0
								?
								<div className='grid grid-cols-3 place-content-center place-items-center gap-6'>
									<Progress
										aria-label={`Tests completed ${dashboardData?.tests?.completed} out of ${dashboardData?.tests?.total}`}
										strokeColor="#1677ff"
										type="circle"
										format={() => <div className='text-center text-base font-normal'>
											{dashboardData?.tests?.completed}/{dashboardData?.tests?.total}<br />Tests
										</div>}
										size={100}
										trailColor="#FAF9F6"
										percent={(Number(dashboardData?.tests?.completed) / Number(dashboardData?.tests?.total)) * 100}
									/>
									<Progress
										aria-label={`Tutorials completed ${dashboardData?.tutorials?.completed} out of ${dashboardData?.tutorials?.total}`}
										strokeColor="#1677ff"
										type="circle"
										format={() => <div className='text-center text-base font-normal'>
											{dashboardData?.tutorials?.completed}/{dashboardData?.tutorials?.total}<br />Tutorials
										</div>}
										percent={(Number(dashboardData?.tutorials?.completed) / Number(dashboardData?.tutorials?.total)) * 100}
										size={100}
										trailColor="#FAF9F6"
									/>
									<Progress
										aria-label={`Flashcards completed ${dashboardData?.flashcards?.completed} out of ${dashboardData?.flashcards?.total}`}
										strokeColor="#1677ff"
										type="circle"
										format={() => <div className='text-center text-base font-normal'>
											{dashboardData?.flashcards?.completed}/{dashboardData?.flashcards?.total}<br />Flashcards
										</div>}
										percent={(Number(dashboardData?.flashcards?.completed) / Number(dashboardData?.flashcards?.total)) * 100}
										size={100}
										trailColor="#FAF9F6"
									/>
								</div> :
								<div>
									{constants.MyProgressNullMsg}
								</div>
							}
						</div>
						{contextHolder}
					</Col>
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<section
							aria-labelledby="dashboard-updates-heading"
							className="smart-crds"
						>
							<h2
								id="dashboard-updates-heading"
								className="sr-only"
							>
								Dashboard Updates
							</h2>
							<div
								className='flex justify-between items-center smart-crds pr-1.5'
								role="region"
								aria-roledescription="carousel"
								onFocus={() => setIsAutoPlay(false)}
								onBlur={() => setIsAutoPlay(true)}
								onMouseEnter={() => setIsAutoPlay(false)}
								onMouseLeave={() => setIsAutoPlay(true)}
							>
								{showCarouselbutton ?
									<Button
										onClick={() => {
											setIsAutoPlay(false);
											handlePrev();
										}}
										type='text'
										icon={<LeftCircleFilled aria-hidden="true" />}
										size='large'
										aria-label="Previous dashboard update"
										className={keyboardFocusableClass}
									/> :
									null}
								<Button
									className="sr-only"
									onClick={() => setIsAutoPlay((prev) => !prev)}
									aria-label={isAutoPlay ? "Pause carousel updates" : "Resume carousel updates"}
								>
									{isAutoPlay ? "Pause" : "Resume"}
								</Button>
								<Carousel
									dots={false}
									ref={carouselRef}
									autoplay={isAutoPlay}
									autoplaySpeed={4000}
								>
									{Number(dashboardData?.tests?.completed) === testPerCard.twentyfive ||
										Number(dashboardData?.tests?.completed) === testPerCard.fifty ||
										Number(dashboardData?.tests?.completed) === testPerCard.seventyfive ||
										Number(dashboardData?.tests?.completed) === Number(dashboardData?.tests?.total) ? (
										<div
											role="group"
											aria-roledescription="slide"
											aria-label="Progress milestone update"
										>
											<Card className='keyboard-focus-card border border-solid border-purple-800 bg-purple-200 w-full h-40'>
												<article aria-labelledby="progress-card-heading">
													<h3
														id="progress-card-heading"
														className="sr-only"
													>
														Progress Milestone
													</h3>
													{getTestPerCard()}
												</article>
											</Card>
										</div>
									) : null}
									<div
										role="group"
										aria-roledescription="slide"
										aria-label="Progress milestone update"
									>
										<Card className='keyboard-focus-card border border-solid border-purple-800 bg-purple-200 w-full h-40'>
											<article aria-labelledby="feedback-card-heading">
												<h3
													id="feedback-card-heading"
													className="uppercase pb-2 text-black">
													<strong>{constants.FeedbackTitle}</strong>
												</h3>
												<Row gutter={[0, 18]} className="w-full items-center">
													<Col xs={12} sm={10} md={5} lg={10} xl={5} className="text-center">
														<SolutionOutlined className='text-6xl text-purple-900' aria-hidden="true" />
													</Col>
													<Col xs={12} sm={14} md={19} lg={14} xl={19} className='mt-1.5'>
														<Typography.Paragraph className="!mb-0"><a aria-label="Click to provide feedback" href="#feedback-modal" onClick={(event) => { event.preventDefault(); feedback(); }} className={keyboardFocusableClass}>Click to provide feedback</a> {constants.FeedbackMessage}</Typography.Paragraph>
													</Col>
												</Row>
											</article>
										</Card>
									</div>
									{testPausedCount > 0 ?
										<div
											role="group"
											aria-roledescription="slide"
											aria-label="Paused tests update"
										>
											<Card className='keyboard-focus-card border border-solid border-purple-800 bg-purple-200 w-full h-40'>
												<article aria-labelledby="paused-tests-heading">
													<h3
														id="paused-tests-heading"
														className="uppercase pb-2 text-black"
													>
														<strong>{constants.pausedTests}</strong>
													</h3>
													<Row gutter={[0, 18]} className="w-full">
														<Col xs={12} sm={14} md={19} lg={14} xl={19} className='mt-1.5'>
															<Typography.Paragraph className="!mb-0">
																You have {testPausedCount} {testPausedCount === 1 ? "test paused. " : "tests paused. "}
																<a aria-label={`Click here ${testPausedCount === 1 ? constants.pausedCard3 : constants.pausedCard2}`} href="#paused-tests" onClick={(event) => { event.preventDefault(); testScore(); }} className={keyboardFocusableClass}>
																	Click here {testPausedCount === 1 ? constants.pausedCard3 : constants.pausedCard2}
																</a>
															</Typography.Paragraph>
														</Col>
													</Row>
												</article>
											</Card>
										</div>
										: null}
								</Carousel>
								{showCarouselbutton ? <Button onClick={() => { setIsAutoPlay(false); handleNext(); }} type="text" icon={<RightCircleFilled aria-hidden="true" />} size='large' aria-label="Next" className={keyboardFocusableClass} /> : null}
							</div>
						</section>
					</Col>
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<div className='w-full border border-gray-300 leading-8 rounded-lg p-3'>
							<h2 className='text-center text-base leading-6 mb-1'>
								<strong>{constants.DashboardChaptHeader}</strong>
							</h2>
							<ul className="space-y-2">
								{dashboardData?.chapters?.map((chapterDetails, index) => (
									<li key={chapterDetails.chapter_id}>
										<Button
											type="text"
											block
											onClick={() => routeToChapter(chapterDetails?.chapter_id)}
											aria-label={`${chapterDetails?.chapter_title}`}
											className={`
												!h-auto
												!p-0
												border
												rounded-lg
												overflow-hidden
												text-left
												${keyboardFocusableClass}`}
											style={{
												borderColor: colorCode[index % colorCode.length],
											}}
										>
											<div className="flex justify-between items-stretch w-full min-w-0">
												<div className='flex items-center gap-2 flex-1 min-w-0'>
													<span
														style={{
															backgroundColor: colorCode[index % colorCode.length]
														}}
														className='text-center text-white w-9 min-w-[36px] self-stretch flex items-center justify-center'
													>
														{chapterDetails?.chapter_id}
													</span>
													<span className='font-semibold break-words whitespace-normal leading-6 flex-1 min-w-0'>
														{chapterDetails?.chapter_title}
													</span>
												</div>
												<span
													className='pr-3 shrink-0'
													aria-hidden="true"
												>
													{'>>'}
												</span>
											</div>
										</Button>
									</li>
								))}
							</ul>
						</div>
					</Col>
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<Row gutter={[8, 8]}>
							<Col xs={24} lg={6}>
								<Card hoverable className={`w-full h-full bg-purple-100 text-center font-semibold ${keyboardFocusableClass}`} onClick={() => navigate('/image-resources')} onKeyDown={(event) => handleKeyboardAction(event, () => navigate('/image-resources'))} role="button" tabIndex={0} aria-label={constants.Images}>
									<FileImageOutlined className='text-5xl' aria-hidden="true" />
									<div className='mt-3'>
										{constants.Images}
									</div>
								</Card>
							</Col>
							<Col xs={24} lg={6}>
								<Card hoverable className={`w-full h-full bg-pink-100 text-center font-semibold ${keyboardFocusableClass}`} onClick={() => navigate('/study-guide-resources')} onKeyDown={(event) => handleKeyboardAction(event, () => navigate('/study-guide-resources'))} role="button" tabIndex={0} aria-label={constants.studyGuide + "s"} >
									<FileTextOutlined aria-hidden="true" className='text-5xl' />
									<div className='mt-3'>
										{constants.studyGuide}s
									</div>
								</Card>
							</Col>
							<Col xs={24} lg={6}>
								<Card hoverable className={`w-full h-full bg-orange-200 text-center font-semibold ${keyboardFocusableClass}`} onClick={() => navigate('/video-resources')} onKeyDown={(event) => handleKeyboardAction(event, () => navigate('/video-resources'))} role="button" tabIndex={0} aria-label={constants.Videos}>
									<PlayCircleOutlined className='text-5xl' aria-hidden="true" />
									<div className='mt-3'>
										{constants.Videos}
									</div>
								</Card>
							</Col>
							<Col xs={24} lg={6}>
								<Card hoverable className={`w-full h-full bg-green-100 text-center font-semibold ${keyboardFocusableClass}`} onClick={() => navigate('/audio-resources')} onKeyDown={(event) => handleKeyboardAction(event, () => navigate('/audio-resources'))} role="button" tabIndex={0} aria-label={constants.Podcast} >
									<AudioOutlined className='text-5xl' aria-hidden="true" />
									<div className='mt-3'>
										{constants.Podcast}s
									</div>
								</Card>
							</Col>
							<Col xs={24} lg={12}>
								<Card
									hoverable
									className={`w-full h-full bg-blue-100 font-semibold flex justify-center ${keyboardFocusableClass}`}
									onClick={testScore}
									onKeyDown={(event) => handleKeyboardAction(event, testScore)}
									role="button"
									tabIndex={0}
									aria-label="Test Score Comparison"
								>
									<Space>
										<BarChartOutlined className="text-3xl text-black" aria-hidden="true" />
										<div className="text-base leading-tight text-black">
											Test Score Comparison
										</div>
									</Space>
								</Card>
							</Col>
							<Col xs={24} lg={12}>
								<Card
									hoverable
									className={`w-full h-full bg-yellow-200 font-semibold flex justify-center ${keyboardFocusableClass}`}
									onClick={myNotes}
									onKeyDown={(event) => handleKeyboardAction(event, myNotes)}
									role="button"
									tabIndex={0}
									aria-label={constants.MyNotes}
								>
									<Space>
										<ReadOutlined className="text-3xl text-black" aria-hidden="true" />
										<div className="text-base leading-tight text-black">
											{constants.MyNotes}
										</div>
									</Space>
								</Card>
							</Col>
							<Col span={24}>
								<div className='p-3'>
									{graphData.length > 0 ?
										<>
											<h2 className='text-center relative top-7 z-10'><strong>{constants.LastThreeTestScoreLabel}</strong></h2>
											<Row>
												<Col xs={24} lg={20}>
													{/* Screen reader description */}
													<p id="latest-test-scores-chart-desc" className="sr-only">
														{/* {chartDescription} */}
														{getGraphDataDescription()}
													</p>
													<div
														role="img"
														aria-label={constants.LastThreeTestScoreLabel}
														aria-describedby="latest-test-scores-chart-desc"
													>
														<Chart
															loader={<div><p className="pt-4">Loading Chart...</p><Skeleton active /></div>}
															chartType="ColumnChart"
															options={chartOptions}
															width="100%"
															height="280px"
															data={graphData}
														/>
													</div>
												</Col>
												<Col xs={24} lg={4}>
													<div className='grid grid-cols-3 lg:grid-cols-1 place-content-center place-items-start gap-2 h-full'>
														{graphData?.slice(1)?.map(([label, value, color]) => {
															return <Space key='color-indicator'>
																<span className='w-5 h-5 block rounded' style={{ backgroundColor: color }}></span>
																{label}
															</Space>
														})}
													</div>
												</Col>
											</Row>
										</>
										:
										<>
											<div className='grid place-content-center place-items-center min-h-[126px]'>
												<div>You have not attempted any Tests.</div>
												<div>View the resources in each Chapter to attempt any Test.</div>
											</div>
										</>
									}
								</div>
							</Col>
						</Row>
					</Col>
				</Row>
				{/* Feedback modal */}
				{isFeedbackModalVisible && feedbackModal()}
				{updateprofileModalVisible && displayUpdateProfileForm()}
			</div>
		</>
	)
}
export default Dashboard

